export default "__VITE_ASSET__4a6addf9__"